module.exports = __webpack_public_path__ + "img/daichuzhishijianzongshu.dee88410.png";